import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ArticleComponent } from "./article/article.component";

@NgModule({
	imports: [CommonModule],
	declarations: [ArticleComponent],
	exports: [ArticleComponent],
})
export class ArticleModule {}
